import { useCallback, useEffect, useState } from 'react';
import { assessmentsApi } from '@/lib/api';
import type { AssessmentSummaryItem } from '@/lib/assessment';

type State = {
  byJob: Record<string, AssessmentSummaryItem>;
  loading: boolean;
};

/**
 * Loads the latest assessment per job once (for list/detail badges) and exposes
 * a `refresh` so callers can re-sync after a new attempt is submitted.
 */
export function useAssessmentSummaries() {
  const [state, setState] = useState<State>({ byJob: {}, loading: true });

  const refresh = useCallback(async () => {
    try {
      const res = await assessmentsApi.getSummaries();
      if (!res.ok) {
        setState({ byJob: {}, loading: false });
        return;
      }
      const data = (await res.json()) as { items: AssessmentSummaryItem[] };
      const byJob: Record<string, AssessmentSummaryItem> = {};
      for (const item of data.items) byJob[item.jobId] = item;
      setState({ byJob, loading: false });
    } catch {
      setState((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { ...state, refresh };
}
